import { render } from "./SliderPromoActivas.vue?vue&type=template&id=7061e0b2&scoped=true"
import script from "./SliderPromoActivas.vue?vue&type=script&lang=js"
export * from "./SliderPromoActivas.vue?vue&type=script&lang=js"

import "./SliderPromoActivas.vue?vue&type=style&index=0&id=7061e0b2&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7061e0b2"]])

export default __exports__